import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { object } from 'prop-types';
import { streams } from '../../services/ApiService';
import {
  startSetStreamSettings,
  startSetGlobalPostback,
  startEditGlobalPostback,
} from '../../actions/streams';
import Layout from '../../components/Layout/Layout';
import GlobalPostbackForm from '../../components/Postback/GlobalPostbackForm';
import WithAlert from '../../hoc/WithAlert';
import { iFMessage } from '../../hoc/IntlComponents';

class GlobalPostbackPage extends Component {
  static propsTypes = {
    settings: object.isRequired,
  };

  state = {
    loading: false,
    response: null,
    modal: false,
    errors: {},
  };

  componentDidMount() {
    this.setState(() => ({ loading: true }));

    this.props
      .startSetStreamSettings()
      .then(() => this.props.startSetGlobalPostback())
      .then(() => this.setState(() => ({ loading: false })))
      .catch(({ response = {} }) => this.handleError(response));
  }

  checkPostback = postback => {
    this.setState(() => ({ loading: true }));

    streams
      .checkPostback(postback)
      .then(({ items }) => {
        const data = items[0];

        this.setState(() => ({
          loading: false,
          response: data.response,
        }));

        this.toggleModal();
      })
      .catch(({ response = {} }) => this.handleError(response));
  };

  handleError = response => {
    this.setState(() => ({ loading: false }));

    if (response.data && response.data.error) {
      const { message: error } = response.data.error;

      this.props.showAlert({
        alertType: 'danger',
        message: error.message,
        dismissable: false,
        closeInSeconds: 3,
      });
    }
  };

  handleSubmit = data => {
    const {intl} = this.props;
    this.setState(() => ({ loading: true }));
    this.props
      .startEditGlobalPostback(data)
      .then(() => {
        this.setState(() => ({ loading: false }));

        this.props.showAlert({
          alertType: 'success',
          message: iFMessage({intl, id: 'postback.global.saved'}),
          dismissable: false,
          closeInSeconds: 3,
        });
      })
      .catch(({ response = {} }) => this.handleError(response));
  };

  toggleModal = () => {
    this.setState(prevState => ({ modal: !prevState.modal }));
  };

  render() {
    const { settings } = this.props;
    const { modal, response, loading } = this.state;

    return (
      <Layout formattedTitle="postback.global.title">
        <Layout.Col>
          <GlobalPostbackForm
            loading={loading}
            postback={settings.globalPostback}
            statuses={settings.postBackStatuses}
            onCheckPostback={this.checkPostback}
            onSubmit={this.handleSubmit}
          />
        </Layout.Col>

        <Modal size="lg" isOpen={modal} toggle={this.toggleModal}>
          <ModalHeader toggle={this.toggleModal}>
            <FormattedMessage id="flow.modal.postback-response" defaultMessage="Postback reponse" />
          </ModalHeader>
          <ModalBody>
            <pre>{response}</pre>
          </ModalBody>
        </Modal>
      </Layout>
    );
  }
}

const mapStateToProps = state => ({
  settings: state.streams.settings,
});
const mapDispatchToProps = dispatch => ({
  startSetStreamSettings: () => dispatch(startSetStreamSettings()),
  startSetGlobalPostback: () => dispatch(startSetGlobalPostback()),
  startEditGlobalPostback: data => dispatch(startEditGlobalPostback(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WithAlert(injectIntl(GlobalPostbackPage)));
